import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ReservaParcela } from '../interfaces/reservaParcela.interface';

const base_url = `${ environment.base_url }/ReservasParcela`;


@Injectable({
  providedIn: 'root'
})
export class ReservasParcelaService {
  token:string = localStorage.getItem('tp-Token') || '';
  headers = new HttpHeaders({
    'Content-Type':'application/x-www-form-urlencoded',
    'Tp-Token': localStorage.getItem('tp-Token') || ''
  });

  constructor(private http: HttpClient) { }

  nuevo(data:ReservaParcela){
    const url = `${ base_url }/postReserva`;
    
    return this.http.post(url, data, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          const respuesta = {status:resp.status, detalle:resp.detalle};
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  actualizar(data:ReservaParcela){
    const url = `${ base_url }/putReserva/${data.id}`;
    
    return this.http.post(url, data, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          const respuesta = {status:resp.status, detalle:resp.detalle};
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

   borrarReserva(id:number){
    const url = `${ base_url }/borrarReserva/${id}`;
    // console.log(url);
    
    return this.http.get(url, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          const respuesta = {status:resp.status, detalle:resp.detalle};
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  getReservasIdParcela(id: number){
    const url = `${ base_url }/getReservasIdParcela/${id}`;
    // console.log(url);
    
    return this.http.get(url, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          const respuesta = {status:resp.status, detalle:resp.detalle};
                          return respuesta;
                        }
                      )
                    );
  }

  getReservasFecha(desdeFecha: number, hastaFecha: number){
    const url = `${ base_url }/getReservasFecha/${desdeFecha}/${hastaFecha}`;
    // console.log(url);
    
    return this.http.get(url, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          const respuesta = {status:resp.status, detalle:resp.detalle};
                          return respuesta;
                        }
                      )
                    );
  }

  busqueda(valor:string, pagina:number, rows:number, orden: string){
    const url = `${ base_url }/getBusquedaReserva/${valor}?page=${pagina}&rows=${rows}&order=${orden}`;
    
    return this.http.get(url, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          const respuesta = {status:resp.status, totalPaginas: resp.totalPaginas, detalle:resp.detalle};
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  getAll(pagina:number, rows:number, orden:string, desc:number, desdeFecha: string, hastaFecha: string){
    const url = `${ base_url }/getAll?page=${pagina}&rows=${rows}&order=${orden}&desc=${desc}&defec=${desdeFecha}&hafec=${hastaFecha}`;
    
    return this.http.get(url, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          // console.log(resp);
                          const respuesta = {status:resp.status, totalPaginas: resp.totalPaginas, detalle:resp.detalle};
                          
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

}
